import React from 'react'
import InputField from 'admin/components/shared/InputField'

export default ({q, onSubmit}) => {
  const handleSearch = changes => onSubmit({...changes, page: 1})

  return (
    <form className='box is-radiusless is-shadowless has-background-filters'>
      <div className='field is-grouped'>
        <div className='control is-expanded'>
          <InputField
            type='search'
            name='q'
            label='Search'
            autoComplete='off'
            value={q}
            debounce={true}
            onChange={handleSearch}
          />
        </div>
      </div>
    </form>
  )
}
